"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FiltersSelected = void 0;
const react_1 = __importDefault(require("react"));
const SelectedFilters_1 = __importDefault(require("@appbaseio/reactivesearch/lib/components/basic/SelectedFilters"));
const components_1 = require("../../components");
const FiltersSelected = props => {
  var _a;
  const RenderComponent = (_a = props.render) !== null && _a !== void 0 ? _a : components_1.ExampleFiltersSelected;
  return react_1.default.createElement(SelectedFilters_1.default, {
    render: _ref => {
      let {
        selectedValues,
        setValue
      } = _ref;
      const selectedFilters = Object.entries(selectedValues).filter(_ref2 => {
        let [key, item] = _ref2;
        var _a, _b;
        return (item === null || item === void 0 ? void 0 : item.URLParams) && (item === null || item === void 0 ? void 0 : item.showFilter) && (!!((_a = item === null || item === void 0 ? void 0 : item.value) === null || _a === void 0 ? void 0 : _a.length) || !!((_b = item === null || item === void 0 ? void 0 : item.value) === null || _b === void 0 ? void 0 : _b.label));
      }).map(_ref3 => {
        let [key, item] = _ref3;
        return {
          key: key,
          label: item.label,
          value: item.value
        };
      });
      const handleRemove = selectedFilterKey => {
        setValue(selectedFilterKey, null);
      };
      if (!selectedFilters.length) {
        return null;
      }
      return react_1.default.createElement(RenderComponent, {
        selectedFilters: selectedFilters,
        handleRemove: handleRemove
      });
    }
  });
};
exports.FiltersSelected = FiltersSelected;